var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"code-mirror-editor"},[_c('codemirror',{attrs:{"options":_vm.cmOptions},model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }